import { render } from "./RIONews.vue?vue&type=template&id=593e17bc&scoped=true"
import script from "./RIONews.vue?vue&type=script&lang=js"
export * from "./RIONews.vue?vue&type=script&lang=js"

import "./RIONews.vue?vue&type=style&index=0&id=593e17bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593e17bc"]])

export default __exports__